import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

const fields = () => {
  return [
    {
      label: 'Pelanggan Penerima',
      key: 'delivery_order.shipped_customer.name',
      isShow: true,
    },
    {
      label: 'Vendor',
      key: 'vendor.name',
      isShow: hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']),
    },
    {
      label: 'Kategori Industri',
      key: 'delivery_order.shipped_customer.industry_category.name',
      isShow: true,
    },
    {
      label: 'No. Penugasan',
      key: 'fleet_task.number',
      isShow: true,
    },
    {
      label: 'Status Penugasan',
      key: 'fleet_task.status.name',
      isShow: true,
    },
    {
      label: 'Status Penugasan',
      key: 'fleet_task.status.name',
      isShow: true,
    },
    {
      label: 'Plat Nomor',
      key: 'fleet_task.vehicle.license_plate',
      isShow: true,
    },
    {
      label: 'Pengemudi',
      key: 'fleet_task.driver_user.name',
      isShow: true,
    },
    {
      label: 'No. Pengiriman',
      key: 'delivery_order.number',
      isShow: true,
    },
    {
      label: 'No. AJU',
      key: 'delivery_order.aju_number',
      isShow: true,
    },
    {
      label: 'No. Shipment',
      key: 'delivery_order.shipment_number',
      isShow: true,
    },
    {
      label: 'No. Reference',
      key: 'delivery_order.reference_number',
      isShow: true,
    },
    {
      label: 'Status Pengiriman',
      key: 'delivery_order.status.name',
      isShow: true,
    },
    {
      label: 'Alamat Asal',
      key: 'delivery_order.origin_address.name',
      isShow: true,
    },
    {
      label: 'Alamat Tujuan',
      key: 'delivery_order.destination_address.name',
      isShow: true,
    },
    {
      label: 'Nama Produk',
      key: 'product.name',
      isShow: true,
    },
    {
      label: 'Kategori Produk',
      key: 'product.category.name',
      isShow: true,
    },
    {
      label: 'Kuantitas',
      key: 'quantity',
      isShow: true,
    },
    {
      label: 'Satuan Kuantitas',
      key: 'uom',
      isShow: true,
    },
    {
      label: 'Volume (Cbm)',
      key: 'volume',
      isShow: true,
    },
    {
      label: 'Berat (Kg)',
      key: 'weight',
      isShow: true,
    },
    {
      label: 'Catatan',
      key: 'note',
      isShow: true,
    },
  ]
}

export default fields
